/* eslint-disable react/no-array-index-key */
import { useFormContext, useWatch } from 'react-hook-form';
import { type CatalogRequestFormValues, combinePhone } from '@/components/CatalogRequestStepper/config';
import CTNCheckbox from '@ctn/ui/components/ctn-checkbox';

type ResumeDataStepProps = {
	readonly title: string;
};

const classNameComponent = 'c-cnm-catalog-stepper';

export const ResumeDataStep = ({ title }: ResumeDataStepProps) => {
	const { formState, control } = useFormContext<CatalogRequestFormValues>();
	const values = useWatch({ control });
	const phoneFull = combinePhone({
		country: values.movil?.country ?? '',
		number: values.movil?.number ?? '',
	});

	return (
		<div className={`${classNameComponent}__step`}>
			<h3 className={`${classNameComponent}__step-title`}>{title}</h3>

			<div className={`${classNameComponent}__resume`}>
				<div className={`${classNameComponent}__resume-content [ o-grid ] [ u-mt-16 ]`}>
					<div className="o-grid__row  [ u-mb-24 ]">
						<div className="o-grid__col-12 o-grid__col-6@landscape o-grid__col-6@hd">
							<div className={`${classNameComponent}__resume-item`}>
								<label className={`${classNameComponent}__resume-item-label`}>
									Nombre completo o razón social
								</label>
								<span>{values.name}</span>
							</div>
						</div>
						<div className="o-grid__col-12 o-grid__col-6@landscape o-grid__col-2@hd">
							<div className={`${classNameComponent}__resume-item`}>
								<label className={`${classNameComponent}__resume-item-label`}>NIF</label>
								<span>{values.nif}</span>
							</div>
						</div>
						<div className="o-grid__col-12 o-grid__col-6@landscape o-grid__col-2@hd">
							<div className={`${classNameComponent}__resume-item`}>
								<label className={`${classNameComponent}__resume-item-label`}>Teléfono Móvil</label>
								<span>{phoneFull}</span>
							</div>
						</div>
						<div className="o-grid__col-12 o-grid__col-6@landscape o-grid__col-2@hd">
							<div className={`${classNameComponent}__resume-item`}>
								<label className={`${classNameComponent}__resume-item-label`}>Email</label>
								<span>{values.email}</span>
							</div>
						</div>
					</div>

					<div className="o-grid__row [ u-mb-24 ]">
						<div className="o-grid__col-12 o-grid__col-6@landscape">
							<div className={`${classNameComponent}__resume-item`}>
								<label className={`${classNameComponent}__resume-item-label`}>Dirección de envio</label>
								<span>{values.direccion}</span>
							</div>
						</div>
						<div className="o-grid__col-12 o-grid__col-6@landscape">
							<div className={`${classNameComponent}__resume-item`}>
								<label className={`${classNameComponent}__resume-item-label`}>
									Dirección de facturación
								</label>
								<span>{values.direccionFacturacion ?? '(misma u otra no indicada)'}</span>
							</div>
						</div>
					</div>

					<div className={`${classNameComponent}__resume-productList`}>
						<div className={`o-grid__row [ u-mb-6 ] ${classNameComponent}__resume-tableRow`}>
							<div className="o-grid__col-12 o-grid__col-6@landscape">
								<div className={`${classNameComponent}__resume-item`}>
									<label className={`${classNameComponent}__resume-item-label`}>Título</label>
								</div>
							</div>
							<div className="o-grid__col-12 o-grid__col-6@landscape">
								<div className={`${classNameComponent}__resume-item`}>
									<label className={`${classNameComponent}__resume-item-label`}>Cantidad</label>
								</div>
							</div>
						</div>

						{values.libros?.map((b, i) => (
							<div key={`${b.id}-${i}`} className={`o-grid__row ${classNameComponent}__resume-tableRow`}>
								<div className="o-grid__col-12 o-grid__col-6@landscape">
									<div className={`${classNameComponent}__resume-item`}>
										<label className={`${classNameComponent}__resume-item-title`}>{b.title}</label>
									</div>
								</div>
								<div className="o-grid__col-12 o-grid__col-6@landscape ">
									<div className={`${classNameComponent}__resume-item`}>
										<label className={`${classNameComponent}__resume-qty`}>{b.quantity}</label>
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>

			<div className={`${classNameComponent}__policy`}>
				<h4 className={`${classNameComponent}__policy-title`}>Política de protección de datos</h4>
				<p className={`${classNameComponent}__policy-text`}>
					De conformidad con lo previsto en el Reglamento General de Protección de Datos, el interesado queda
					informado de que sus datos personales serán tratados por el Ilustre Colegio Notarial de Madrid (en
					adelante, ICNM) en calidad de responsable del tratamiento, cuyos datos de contacto son: C/ Ruiz de
					Alarcón, 3 - 28014 Madrid - teléfono 91-213.00.00, e-mail: info@madrid.notariado.org. Los datos se
					utilizarán con la finalidad de llevar a cabo la gestión del servicio prestado. La base jurídica de
					este tratamiento es el cumplimiento del servicio, siendo obligado el suministro de los datos con
					este fin e impediría su cumplimiento en caso contrario. Los datos serán conservados con ese fin
					durante todo el tiempo en que la relación esté vigente y, aún después, durante todo el tiempo
					exigido por la legislación aplicable. Los datos no serán cedidos a terceros, salvo a las
					Administraciones Públicas cuando lo prevea la Ley. Tiene derecho a solicitar el acceso a sus datos
					personales, su rectificación o supresión, así como a la limitación de su tratamiento, a oponerse al
					mismo y a la portabilidad de sus datos. Puede usted presentar una reclamación ante la autoridad de
					control (AEPD). Datos de contacto del Delegado de Protección de Datos: http://www.ctnotariado.com,
					c/ Campezo, nº 1, (28022) Madrid, Edificio 6, pl. 2ª.
				</p>

				<CTNCheckbox
					noFeedBack
					control={control}
					checkbox={{ large: true }}
					name="acceptPolicy"
					items={[
						{
							label: 'He leido y acepto la política de protección de datos.',
							disabled: formState.isSubmitting,
							value: 'acceptPolicy',
						},
					]}
					error={formState.errors.acceptPolicy?.message}
				/>
			</div>
		</div>
	);
};
